import React, { useContext, useState } from "react";
import NewButton from "./NewButton";
import { ReactComponent as Close } from "../assets/icons/x.svg";
import { FormTextInput } from "../Components/FormTextInput";
import { firestore } from "../firebase.config";
import { NotificationContext } from "../Context/NotificationContext";
import { useEnterKey } from "../Hooks/useEnterKey";
import { get2DecimalNumber } from "../Data/Functions";

const expeditedOptions = [{name: "Paid", value: "paid"}, {name: "Free", value: "free"}, {name: "Free+", value: "free-plus"}];

const EditTeamPopUp = ({ onClose, currentTeam }) => {
    const { showNotification } = useContext(NotificationContext);

  const [teamName, setTeamName] = useState(currentTeam ? currentTeam.name : "");
  const [discount, setDiscount] = useState(currentTeam ? currentTeam.discount : "");
  const [selectedExpedited, setSelectedExpedited] = useState(currentTeam ? currentTeam.expeditedServices : expeditedOptions[0].value); 
  const [btnText, setBtnText] = useState("Save");
 
  const updateTeamDetails = async () => {
    if (!teamName.trim()) {
      showNotification("Error", "Team name is required.", "error");
      return;
    }
    setBtnText("Saving...");
    try {
      await firestore.collection("teams").doc(currentTeam.id).update({
        name: teamName,
        discount: !discount || discount === "" ? 0 : discount,
        // discount: !discount || discount === "" ? 0 : get2DecimalNumber(discount),
        expeditedServices: selectedExpedited,
      });

      showNotification("Success", "Team updated successfully!", "success");
      onClose(); 
    } catch (error) {
      showNotification("Error", "Failed to update team. Please try again.", "error");
      console.error("Update error:", error);
    }finally{
      setBtnText("Save");
    }
  };

  useEnterKey(() => updateTeamDetails());


  return (
    <div className="newPopUpModalWrap">
      <div className="employeeUpdateModalContainer">
        <div className="employeeUpdateModalContainerScroll">
          <h2 className="newPopUpModalTitle">
            { "Edit Team" }
          </h2>

          <FormTextInput
            placeholder="Team Name"
            value={teamName}
            onChange={setTeamName}
            
          />
          <FormTextInput
            placeholder="Discount(%)"
            value={discount}
            onChange={setDiscount}
            
          />
          <div className="employeeUpdateforsupport">
            <h4 className="employeePopUpModalTitle">Expedited Service</h4>
            <div className="quoteDetailsInputsContainer">
              {expeditedOptions.map((option,i) => (
                <div
                  key={option.value + i}
                  className={`expeditedButton ${
                    selectedExpedited === option.value ? "selected" : ""
                  }`}
                  onClick={() => setSelectedExpedited(option.value)}
                >
                  <p>{option.name}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="addandEditbutton">
            <NewButton text={btnText} disabled={btnText === "Saving..."} width="100%" onClick={updateTeamDetails} />
            <NewButton text="Cancel" disabled={btnText === "Saving..."} width="100%" onClick={onClose} back={true} icon={false} whiteBtn={true}
            />
          </div>
          <Close className="newPopUpModalCloseIcon" onClick={onClose} />
        </div>
      </div>
    </div>
  );
};

export default EditTeamPopUp;
